import { render } from "./EditBranche.vue?vue&type=template&id=3ed804e8&scoped=true"
import script from "./EditBranche.vue?vue&type=script&lang=js"
export * from "./EditBranche.vue?vue&type=script&lang=js"

import "./EditBranche.vue?vue&type=style&index=0&id=3ed804e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed804e8"]])

export default __exports__